// src/components/setup/SetupGate.jsx
// Wrap your authenticated app with this. If the shop hasn't completed setup,
// it shows the wizard; otherwise it renders the app. Usage in App.js:
//   <SetupGate><Layout /></SetupGate>
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../config/api';
import SetupWizard from './SetupWizard';

export default function SetupGate({ children }) {
  const { data: settings, isLoading, refetch } = useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get('/api/settings').then(r => r.data),
    retry: 1,
  });

  if (isLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontFamily: "'DM Sans','Segoe UI',sans-serif" }}>
        Loading…
      </div>
    );
  }

  if (settings && settings.setup_completed !== true) {
    return <SetupWizard onDone={() => refetch()} />;
  }

  return children;
}
